/** Inbox URLs for the OTP open-mail control. Email comes from checkout props. */

export function getMailInboxUrl(email) {
  const trimmed = String(email || '').trim();
  const domain = (trimmed.split('@')[1] || '').toLowerCase();

  if (domain === 'gmail.com' || domain === 'googlemail.com') {
    return 'https://mail.google.com/mail/mu/mp/0/#tl/inbox';
  }
  if (domain === 'outlook.com' || domain === 'hotmail.com' || domain === 'live.com' || domain === 'msn.com') {
    return 'https://outlook.live.com/mail/0/inbox';
  }
  if (domain === 'yahoo.com' || domain === 'ymail.com') {
    return 'https://mail.yahoo.com/';
  }
  if (domain === 'icloud.com' || domain === 'me.com' || domain === 'mac.com') {
    return 'https://www.icloud.com/mail/';
  }
  return 'mailto:';
}

export function getOtpEmailFromUiParts(uiParts) {
  for (const part of uiParts || []) {
    if (!(part.component || '').includes('checkout')) continue;
    const props = part.props || {};
    if (props.step !== 'otp') continue;
    return props.otpEmail || props.email || null;
  }
  return null;
}

export function resolveOtpMailTarget(message) {
  const email = getOtpEmailFromUiParts(message?.ui_parts);
  if (!email) return null;
  return { email, url: getMailInboxUrl(email) };
}
